import { combineReducers } from 'redux';
import { connectRouter } from 'connected-react-router';
import authReducer from './auth.reducer';
import loadingReducer from './sagasstatus.reducer';
import appReducer from './app.reducer';
import navigableReducer from './navigable.reducer';
import noConformidadesReducer from './noconformidades/noconformidades.reducer';
import clientesReducer from './clientes/clientes.reducer';
import proveedoresReducer from './proveedores/proveedores.reducer';
import rrhhReducer from './rrhh/rrhh.reducer';
import sedesReducer from './sedes/sedes.reducer';
import tipologiasReducer from './tipologias/tipologias.reducer';
import sistemaSubidaFotografias from './sistemaSubidaFotografias/fotografias.reducer';
import sistemaNotificaciones from './sistemaNotificaciones/notificaciones.reducer';
import procesosReducer from './procesos/procesos.reducer';

const reducer = history => combineReducers({
  app: appReducer,
  navigation: navigableReducer,
  auth: authReducer,
  sagas: loadingReducer,
  noConformidades: noConformidadesReducer,
  clientes: clientesReducer,
  proveedores: proveedoresReducer,
  rrhh: rrhhReducer,
  sedes: sedesReducer,
  tipologias: tipologiasReducer,
  sistemaSubidaFotografias,
  sistemaNotificaciones,
  procesos: procesosReducer,
  router: connectRouter(history),
});

export default reducer;
